import { audiencerateApi } from '../../audiencerate';
import { SupportEmailRequest, TermsResponse } from './types';

export const supportApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    sendSupportEmail: build.mutation<void, SupportEmailRequest>({
      query: (body) => ({
        url: `/v1/support`,
        method: 'POST',
        body,
      }),
    }),
    getTerms: build.query<TermsResponse, void>({
      query: () => ({
        url: `/v1/terms`,
      }),
      providesTags: ['Terms'],
    }),
  }),
  overrideExisting: false,
});

export const { useSendSupportEmailMutation, useGetTermsQuery } = supportApi;
